/**
 * Translation status enum 
 * */
export enum TranslationStatusEnum {
  Undefined = 0,
  Pending,
  InProgress,
  Completed
}
